import React, { useState } from 'react'
import { onButtonTriggerKey } from '../../utils'
import getUniqueKey from '../utils/getUniqueKey'

export type ExpandableCellProps = {
  defaultLength: number
  items: string[]
}

const handleClick = (
  setState: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setState((prevExpanded) => !prevExpanded)
}
export const ExpandableCell = ({
  defaultLength,
  items
}: ExpandableCellProps) => {
  const [isExpanded, setState] = useState(false)
  const viewClass = isExpanded ? '' : 'forDemo'
  const displayList = isExpanded ? items : items.slice(0, defaultLength)
  return (
    <ul>
      {items.length &&
        items.map((elem, i) =>
          i < defaultLength ? (
            <li key={getUniqueKey(i)} data-testid="listData">
              {elem}
            </li>
          ) : (
            <li
              className={viewClass}
              data-testid={viewClass === 'forDemo' ? '' : 'listData'}
              key={getUniqueKey(i)}
            >
              {elem}
            </li>
          )
        )}
      {items.length > defaultLength ? (
        <li>
          <span
            className="frw-view-more"
            onClick={() => handleClick(setState)}
            onKeyDown={onButtonTriggerKey(() => handleClick(setState))}
            role="button"
            tabIndex={0}
            aria-expanded={isExpanded}
            aria-label={`${
              isExpanded ? 'VIEW LESS' : 'VIEW MORE'
            }: Currently showing ${displayList.length} of total ${
              items.length
            } items list.`}
          >
            {isExpanded ? 'VIEW LESS' : 'VIEW MORE'}
          </span>
        </li>
      ) : null}
    </ul>
  )
}
